(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("dieselHistoryNotification", {
            parent: "Notification",
            url: "/notification/diesel-history",
            data: {
                authorities: ["bilioslo-admin-dieselvarsel"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/notification/diesel-history/diesel-history.html",
                    controller: "DieselHistoryNotificationController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
